import React from 'react'
import Hero from '@/components/Hero'
import HowItWorksSection1 from '@/components/sections/HowItWorksSection1'
import AwardsSection2 from '@/components/sections/AwardsSection2'
import SecuritySectionSection3 from '@/components/sections/SecuritySectionSection3'
import ContactLocationsSection4 from '@/components/sections/ContactLocationsSection4'
import FaqSection5 from '@/components/sections/FaqSection5'
import BookingCTA from '@/components/BookingCTA'
import Footer from '@/components/Footer'

export default function App() {
  return (
    <>
      <main className="min-h-screen">
        <Hero
          backgroundImageUrl="/images/hero-desktop.png"
          mobileBackgroundImageUrl="/images/hero-mobile.png"
        />
        <HowItWorksSection1 />
        <AwardsSection2 />
        <SecuritySectionSection3 />
        <ContactLocationsSection4 />
        <BookingCTA />
        <FaqSection5 />
      </main>
      <Footer />
    </>
  )
}
